import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { cardStyles } from '../../styles/card';
import { medal, trophy } from '../../svg';

@customElement('umb-market-award-card')
export class UmbMarketAwardCard extends LitElement {
  @property()
  title!: string;

  @property()
  path!: string;

  @state()
  _isHOF = false;

  connectedCallback() {
    super.connectedCallback();
    this._isHOF = Number.isNaN(Number(this.path));
  }

  render() {
    return html`
      <a
        role="button"
        class="card ${this._isHOF ? 'hof' : ''}"
        href=${`/awards/${this.path}`}
      >
        <div class="card-body">
          <div class="flex">
            <div class="dinkus">
              ${this._isHOF ? trophy : medal}
              <div>
                <h3>${this.title}</h3>
              </div>
            </div>
          </div>
        </div></a
      >
    `;
  }

  static styles = [
    cardStyles,
    css`
      svg {
        width: 44px;
        height: 44px;
      }

      h3 {
        font-weight: 500;
      }

      .hof,
      .card.hof:hover {
        --fill: var(--uui-color-surface);

        border-color: var(--uui-color-current-contrast);
        background: var(--uui-color-current-contrast);
        color: var(--fill);
      }

      .card:not(.hof),
      .card:not(.hof):hover {
        --fill: var(--uui-color-surface);

        background: var(--uui-color-default);
        color: var(--fill);
      }
    `,
  ];
}
